import React from "react";
import { Box, Button, Container, Grid, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const MarketingInfoBar = () => {
  return (
    <Box
      sx={{
        mt: { xs: 4, md: 6 },
        pt: { xs: 6, md: 8 },
        pb: { xs: 3, md: 4 },
        borderTop: "1px solid var(--ink-3)",
        background: "var(--ink-1)",
        color: "var(--ink-7)",
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        <Grid container spacing={4} alignItems="flex-start">
          {/* Logo */}
          <Grid item xs={12} md={3}>
            <Box
              sx={{
                maxWidth: 190,
                mx: { xs: "auto", md: 0 },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src="/infrablaze-logo.png"
                alt="InfraBlaze"
                sx={{ width: "100%", maxWidth: 132, display: "block" }}
              />
              <Typography
                sx={{
                  mt: 1,
                  fontSize: { xs: 28, md: 32 },
                  fontWeight: 900,
                  letterSpacing: 0.2,
                  lineHeight: 1,
                  textAlign: "center",
                  fontFamily: "var(--f-display)",
                }}
              >
                <Box component="span" sx={{ color: "var(--ink-9)" }}>
                  Infra
                </Box>
                <Box component="span" sx={{ color: "var(--amber)" }}>
                  Blaze
                </Box>
              </Typography>
            </Box>
          </Grid>

          {/* Link columns */}
          <Grid item xs={12} md={9}>
            <Grid container spacing={{ xs: 4, md: 6 }} sx={{ pt: 3 }}>
              <Grid item xs={12} sm={4}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 900,
                    mb: 1.5,
                    textTransform: "uppercase",
                    letterSpacing: 1,
                  }}
                >
                  Company
                </Typography>
                <Stack spacing={0.8}>
                  <Button
                    component={RouterLink}
                    to="/about"
                    variant="text"
                    size="small"
                    sx={{ justifyContent: "flex-start", px: 0 }}
                  >
                    About
                  </Button>
                  <Button
                    component={RouterLink}
                    to="/pricing"
                    variant="text"
                    size="small"
                    sx={{ justifyContent: "flex-start", px: 0 }}
                  >
                    Pricing
                  </Button>
                  <Button
                    component={RouterLink}
                    to="/contact"
                    variant="text"
                    size="small"
                    sx={{ justifyContent: "flex-start", px: 0 }}
                  >
                    Contact
                  </Button>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 900,
                    mb: 1.5,
                    textTransform: "uppercase",
                    letterSpacing: 1,
                  }}
                >
                  Resources
                </Typography>
                <Stack spacing={0.8}>
                  <Button
                    component={RouterLink}
                    to="/faqs"
                    variant="text"
                    size="small"
                    sx={{ justifyContent: "flex-start", px: 0 }}
                  >
                    FAQs
                  </Button>
                  <Button
                    component={RouterLink}
                    to="/docs"
                    variant="text"
                    size="small"
                    sx={{ justifyContent: "flex-start", px: 0 }}
                  >
                    Docs & Guides
                  </Button>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 900,
                    mb: 1.5,
                    textTransform: "uppercase",
                    letterSpacing: 1,
                  }}
                >
                  Community
                </Typography>
                <Stack spacing={0.8}>
                  <Button
                    component="a"
                    href="https://www.linkedin.com/company/infrablaze"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="text"
                    size="small"
                    sx={{ justifyContent: "flex-start", px: 0 }}
                  >
                    LinkedIn
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default MarketingInfoBar;
